import isArray from 'lodash/isArray';

import { Nullable } from 'chaika-common-types';

import { PresetFilter } from '@components/Table/filters/PresetFilters/PresetFilters';

interface Data {
    parseValueToArray(presetFilter: PresetFilter): Record<string, Nullable<string>[] | boolean>;
}

export function usePresetFilters(): Data {
    function parseValueToArray(presetFilter: PresetFilter): Record<string, Nullable<string>[] | boolean> {
        const filters: Record<string, Nullable<string>[] | boolean> = {};

        for (const key in presetFilter.filters) {
            const value = presetFilter.filters[key];
            const isBoolean = typeof value === 'boolean';
            filters[key] = isArray(value) || isBoolean ? value : [value];
        }

        return filters;
    }

    return {
        parseValueToArray,
    };
}
